export default __webpack_public_path__ + "static/media/order-at-table.57c9be75.jpg";